import { getTelephonyErrorMessage } from "./telephonyErrorMessages";

/**
 * Dials using browser phone (SIP.js, Linkus SDK, or native SIP).
 */
export const placeCall = async ({
  browserPhoneEnabled,
  providerName,
  actions,
  createManual,
  phoneNumber,
  accountNo,
  ticketId,
  options = {},
  toast,
  t,
  rethrow = false,
}) => {
  const trimmed = String(phoneNumber || "").trim();
  if (!trimmed) {
    const message = t("ccPhoneNumberRequired");
    toast?.error(message);
    if (rethrow) throw new Error(message);
    return null;
  }

  if (!browserPhoneEnabled) {
    const message = t("ccBrowserPhoneNotEnabled");
    toast?.error(message);
    if (rethrow) throw new Error(message);
    return null;
  }

  try {
    let callLogId = options.callLogId;
    let resolvedAccountNo = accountNo || options.accountNo;

    if (!callLogId && createManual) {
      const payload = {
        accountNo: String(resolvedAccountNo || trimmed).trim(),
        phoneNumber: trimmed,
      };
      if (ticketId) {
        payload.ticketId = ticketId;
      }
      const callResponse = await createManual(payload);
      callLogId = callResponse?.id || callResponse?.callLogId;
      resolvedAccountNo =
        callResponse?.accountId && callResponse.accountId !== "UNKNOWN"
          ? callResponse.accountId
          : payload.accountNo;
    }

    await actions.connect();
    if (typeof actions.ensurePhoneReady === "function") {
      await actions.ensurePhoneReady();
    }
    await actions.startCall(trimmed, {
      ...options,
      callLogId,
      accountNo: resolvedAccountNo,
    });
    return { id: callLogId, phoneNumber: trimmed };
  } catch (error) {
    toast?.error(getTelephonyErrorMessage(error, t, { providerName }));
    if (rethrow) throw error;
    return null;
  }
};

export { connectBrowserPhone, placeBrowserCall, runTelephonyAction } from "./placeBrowserCall";
